/* ============
 * OrderProduct Transformer
 * ============
 *
 * The transformer for the orderProduct.
 */

import Transformer from './transformer';
import productTrans from './product';

export default class OrderProductTransformer extends Transformer {

  static fetch(orderProduct) {
    const product = productTrans.fetch(orderProduct.product);
    const data = Object.assign(product, {
      id: orderProduct.id,
      orderId: orderProduct.order_id,
      name: orderProduct.name,
      note: orderProduct.note,
      billNote: orderProduct.note,
      productId: orderProduct.product_id,
      batchId: orderProduct.batch_id,
      batchName: orderProduct.batch_name,
      taxId: orderProduct.tax_id,
      taxPercentage: orderProduct.tax_percentage,
      description: orderProduct.description,
      price: orderProduct.price,
      quantity: orderProduct.quantity,
      available: orderProduct.available,
      discount: orderProduct.discount,
      total: orderProduct.total,
      totalTax: orderProduct.total_tax,
      ediOrderItemId: orderProduct.edi_order_item_id,
      quantityOrdered: orderProduct.quantity_ordered,
      quantityConfirmed: orderProduct.quantity_confirmed,
      quantityReceived: orderProduct.quantity_received,
      quantityPacked: orderProduct.quantity_packed,
      quantityUnpacked: orderProduct.quantity_unpacked,
      productDeposit: orderProduct.product_deposit,
      productDepositId: orderProduct.product_deposit_id,
      returnCode: orderProduct.return_code,
      returnCodeDescription: orderProduct.return_code_description,
      gtin: orderProduct.gtin,
      batchIds: orderProduct.batch_ids,
      warehouseTransactions: orderProduct.warehouse_transactions,
      unitTypeId: orderProduct.unit_type_id,
      unitQuantity: orderProduct.unit_quantity || '',
      bundleGroupId: orderProduct.bundle_group_id || '',
      prevOrderProductPackage: orderProduct.prev_order_product_package,
    });
    return data;
  }

  static send(orderProduct) {
    return {
      id: orderProduct.id,
      name: orderProduct.name,
      note: orderProduct.note,
      product_id: orderProduct.productId,
      batch_id: orderProduct.batchId,
      tax_id: orderProduct.taxId,
      description: orderProduct.description,
      price: orderProduct.price,
      quantity: orderProduct.quantity,
      discount: orderProduct.discount,
      total: orderProduct.total,
      total_tax: orderProduct.totalTax,
      edi_order_item_id: orderProduct.ediOrderItemId,
      quantity_confirmed: orderProduct.quantityConfirmed,
      quantity_received: orderProduct.quantityReceived,
      product_deposit_id: orderProduct.productDepositId,
      batch_ids: orderProduct.batchIds,
      unit_type_id: orderProduct.unitTypeId,
      unit_quantity: orderProduct.unitQuantity,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/orderProduct.js